import {
  RECEIVE_OPERATIONS,
  RECEIVE_FIELDS,
  RECEIVE_OPERATIONS_AND_FIELDS,
  RECEIVE_MULTIPLE_OPERATIONS,
  RECEIVE_MULTIPLE_OPERATIONS_AND_FIELDS,
  RECEIVE_FIELDS_MULTI_OPERATIONS,
} from '../constants/actionTypes';

export const initialState = {
  allIds: [],
  byId: {},
  current: null,
};

/**
 * Handles redux state for operations, this operations come from the farmer
 * navigation and are not fetched by any saga.
 * If operations were already set it does not update them.
 * @param {Object} state
 * @param {Object} action
 * @return {Object} new state
 */
function operationsReducer(state = initialState, action = {}) {
  switch (action.type) {
    case RECEIVE_OPERATIONS: {
      const { operations } = action;

      const available = !state.allIds.length
        ? operations.reduce((accessible, operation) => ({
          ...accessible,
          [operation.operationId]: { ...operation, fields: [] },
        }), {})
        : state.byId;
      return {
        current: [action.operationId],
        byId: available,
        allIds: operations.map(op => op.operationId),
      };
    }
    case RECEIVE_MULTIPLE_OPERATIONS: {
      const { allOperations, selectedOperations } = action;
      const available = !state.allIds.length
        ? allOperations.reduce((accessible, operation) => ({
          ...accessible,
          [operation.operationId]: { fields: [] },
        }), {})
        : state.byId;
      return {
        current: selectedOperations,
        byId: available,
        allIds: allOperations.map(op => op.operationId),
      };
    }
    case RECEIVE_FIELDS: {
      const byId = state.allIds.reduce((accessible, id) => {
        const operation = state.byId[id];
        const fields = action.payload.reduce((ids, field) => id === 'all-operations' ||
          field.userId === operation.operationOwnerId
          ? [...ids, `${field.id}`]
          : ids, []);
        return {
          ...accessible,
          [id]: { ...operation, fields: [...operation.fields, ...fields] },
        };
      }, {});
      return { ...state, byId };
    }
    case RECEIVE_FIELDS_MULTI_OPERATIONS: {
      const byId = state.allIds.reduce((accessible, id) => {
        const operation = state.byId[id];
        const fields = action.payload.reduce((ids, field) => field.tenantId === id
          ? [...ids, `${field.id}`]
          : ids, []);
        return {
          ...accessible,
          [id]: { ...operation, fields: [...operation.fields, ...fields] },
        };
      }, {});
      return { ...state, byId };
    }
    case RECEIVE_OPERATIONS_AND_FIELDS: {
      const { operations } = action;
      const available = !state.allIds.length
        ? operations.reduce((accessible, operation) => ({
          ...accessible,
          [operation.operationId]: { ...operation, fields: [] },
        }), {})
        : state.byId;
      const byId = Object.keys(available).reduce((accessible, id) => {
        const operation = available[id];
        const fields = action.fields.reduce((ids, field) => id === 'all-operations' ||
          field.userId === operation.operationOwnerId
          ? [...ids, `${field.id}`]
          : ids, []);
        return {
          ...accessible,
          [id]: { ...operation, fields: [...operation.fields, ...fields] },
        };
      }, {});
      return {
        ...state,
        current: action.operationId,
        byId,
        allIds: Object.keys(available),
      };
    }
    case RECEIVE_MULTIPLE_OPERATIONS_AND_FIELDS: {
      const { selectedOperations, allOperations } = action;

      const available = !state.allIds.length
        ? selectedOperations.reduce((accessibleOperation, operationId) => ({
          ...accessibleOperation,
          [operationId]: { fields: [] },
        }), {})
        : state.byId;
      const byId = Object.keys(available).reduce((accessible, id) => {
        const operation = available[id];
        const fields = action.fields.reduce((ids, field) => field.tenantId === id
          ? [...ids, `${field.id}`] : ids, []);
        return {
          ...accessible,
          [id]: { ...operation, fields: [...operation.fields, ...fields] },
        }
      }, {});
      return {
        ...state,
        current: selectedOperations,
        byId,
        allIds: allOperations.map(op => op.operationId),
      }
    }
    default:
      return state;
  }
}

export default operationsReducer;
